import { Component, OnInit, Renderer2 } from '@angular/core';

import { MainNavInfService } from './main-nav-inf.service';

@Component({
  standalone: false,
  selector: 'main-nav-inf',
  templateUrl: './main-nav-inf.component.html',
  styleUrls: ['./main-nav-inf.component.css']
})
export class MainNavInfComponent implements OnInit {

  ocorrencias: any;
  constructor(private mainNavInfService: MainNavInfService) {

  }

  ngOnInit() {
    this.getInfoGeralOcorrencias();
  }

  async getInfoGeralOcorrencias() {
    const response = await this.mainNavInfService.getInfoGeralOcorrencias();
    this.ocorrencias = response;
  }
}
